import $ from 'jquery';

$('.hero-carousel').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: false,
  fade: true,
  autoplay: true,
  speed: 3000,
  appendDots: $('.dots'),
  cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
  });

  $('.testimonial-carousel').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    autoplay: true,
    speed: 1300,
    autoplaySpeed: 7000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: false,
          dots: true,
        },
      },
    ],
  });